//packages
import React, {Component, PropTypes} from 'react'

//modules
import InfoMessage from '../../Modules/InfoMessage'

//styles
import './LoggedOutInfoMessage.less'

class LoggedOutInfoMessage extends Component {
    render() {
        return (
            <InfoMessage>
                You need to <a href="/user-portal?destination=filings/search-court-filings">login</a> in order to access Case Lookup
            </InfoMessage>
        )
    }
}

export default LoggedOutInfoMessage



// WEBPACK FOOTER //
// ./src/components/Elements/LoggedOutInfoMessage/LoggedOutInfoMessage.js